"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ActionTypes = _interopRequireDefault(require("../constants/ActionTypes"));

var initialState = null;

var ProductBasedOffers = function ProductBasedOffers() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _ActionTypes.default.PRODUCT_BASED_OFFERS_RECEIVED:
      return payload;

    default:
      return state;
  }
};

var _default = ProductBasedOffers;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/reducers/ProductBasedOffers.js
// module id = 528
// module chunks = 5 6